import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Bits";
import { AttentionPanel } from "@/components/AttentionPanel";

const STATS = [
  ["members", "Beta members"],
  ["questions_month", "Questions this month"],
  ["escalated_open", "Waiting for you"],
  ["in_review", "Awaiting your approval"],
  ["kb_entries", "Knowledge bank entries"],
  ["helpful", "Marked helpful"],
  ["not_helpful", "Marked not helpful"],
];

const ROUTINE = [
  "Approve or edit AI answers waiting in 'Needs approval' (while review mode is on).",
  "Clear the escalation queue: answer, and tick 'add to knowledge bank' so the AI learns it.",
  "Updated your knowledge bank in Claude? Re-upload the .md in Knowledge bank → Sync from .md.",
  "Open Answer reports: fix any flagged knowledge gaps and skim answers marked not helpful.",
  "Add one new entry from this week's client work, a talk or an article you wrote.",
  "Check fair-use limits and member activity in Members & settings.",
];

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader eyebrow="Lindsay's kitchen" title="Today in the club." />
      <AttentionPanel />
      <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-4 mb-12">
        {STATS.map(([k, label], i) => (
          <div key={k} className={`fade-up min-w-0 rounded-2xl border p-6 ${["escalated_open", "in_review"].includes(k) && s?.[k] ? "border-rose-300 bg-rose-50" : "border-border bg-card"}`} style={{ animationDelay: `${i * 60}ms` }} data-testid={`admin-stat-${k}`}>
            <div className="font-serif text-4xl">{s ? s[k] : "–"}</div>
            <div className="mt-2 text-[11px] font-mono uppercase tracking-wider text-muted-foreground">{label}</div>
          </div>
        ))}
      </div>
      <div className="rounded-2xl border border-border bg-card p-6 lg:p-8 max-w-3xl">
        <div className="eyebrow mb-3">Weekly knowledge bank routine · 30 mins</div>
        <ol className="space-y-3 list-decimal pl-5 text-sm text-foreground/90">
          {ROUTINE.map((r) => <li key={r}>{r}</li>)}
        </ol>
        <div className="mt-6 flex gap-4 text-sm">
          <Link to="/admin/queue" className="text-pinkb hover:underline" data-testid="overview-go-queue">Open queue →</Link>
          <Link to="/admin/kb" className="text-pinkb hover:underline" data-testid="overview-go-kb">Open knowledge bank →</Link>
        </div>
      </div>
    </div>
  );
}
